import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "reactstrap";
import images from '../../../../../common/images/badges';
import {FormattedMessage} from "react-intl";

class BadgeNotification extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true
        }
    }

    toggle = () => {
        this.setState({open: false});
    };

    kindToIdentifier() {
        switch (this.props.notification.data.type) {
            case "Badges::Candidate::ContentUnits": return 'elektrizujici_vykon';
            case "Badges::Candidate::ImportantDocuments": return 'nezdolna_energie';
            case "Badges::Candidate::Articles": return 'zapaleny_ctenar';
            case "Badges::Candidate::PersonalForm": return 'mas_jiskru';
            case "Badges::Candidate::ActivityFirst": return 'jizda_pod_plynem';
            case "Badges::Candidate::ActivitySecond": return 's_plynem_na_podlaze';
            case "Badges::Candidate::LifeAtInnogy": return 'pali_ti_to';
            case "Badges::Candidate::MedicalExam": return 'mas_stavu';

            case "Badges::NewEmployee::MostContentUnits": return 'matador';
            case "Badges::NewEmployee::Articles": return 'demon_administrativy';
            case "Badges::NewEmployee::StylePersonalGrowth": return 'nakrmeny_mozek';
            case "Badges::NewEmployee::ImportantDocuments": return 'dotahovac';
            case "Badges::NewEmployee::AllContentUnits": return 'vseznalek';
            case "Badges::NewEmployee::LifeAtInnogy": return 'zrout_informaci';
            case "Badges::NewEmployee::ActivityFirst": return 'sprinter';
            case "Badges::NewEmployee::ActivitySecond": return 'vytrvalec';

            case "Badges::Manager::SimultaneousTwo": return "zkuseny_pruvodce";
            case "Badges::Manager::SimultaneousFive": return "super_pruvodce";
            case "Badges::Manager::CompletedCandidateCounter": return "sekac";
            case "Badges::Manager::CompletedNewEmployeeCounter": return "dotahovac";
        }
    }

    render() {
        const { notification, dismiss } = this.props;
        const identifier = this.kindToIdentifier();

        return (
            <Modal isOpen={this.state.open} className='modal-badge' onClosed={() => { dismiss(notification); }} toggle={this.toggle}>
                <ModalHeader>
                    <FormattedMessage id={`app.badges.modal.title`} />
                </ModalHeader>
                <ModalBody>
                    <p><img className='badge-image' src={ images.active[identifier] } alt=''/></p>
                    <FormattedMessage id={`app.badges.${identifier}.active_text`}/>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.toggle} color='gasnet-green'><FormattedMessage id='app.actions.close'/></Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default BadgeNotification;
